module.exports = __webpack_public_path__ + "static/img/4.c455ca7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/4.png
// module id = ZkL0
// module chunks = 0